var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.53223,
    cy: 9.96484,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59447 7.15218C5.28381 6.84152 5.28381 6.33784 5.59447 6.02718C5.90512 5.71653 6.4088 5.71652 6.71946 6.02718L13.4694 12.7771C13.7801 13.0878 13.7801 13.5915 13.4694 13.9021C13.1588 14.2128 12.6551 14.2128 12.3444 13.9021L5.59447 7.15218Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3443 6.02738C12.6549 5.71672 13.1586 5.71672 13.4693 6.02737C13.7799 6.33803 13.7799 6.84171 13.4693 7.15237L6.71932 13.9023C6.40866 14.213 5.90498 14.213 5.59432 13.9023C5.28366 13.5917 5.28366 13.088 5.59432 12.7773L12.3443 6.02738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccount);
export default __webpack_public_path__ + "static/media/close_account.d3ff7494cf3ae03e5a4f8d1a2f413819.svg";
export { ForwardRef as ReactComponent };